import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss']
})
export class InputFileComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  MAX_CHARACTERS: number = 15;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'simple',
        titulo: 'Input file simple',
        subtitulo: 'Permite añadir un único archivo',
        componentRender:
          `
  <div class="form-group">
      <label for="input-file-simple">Adjuntar archivo</label>
      <div class="custom-file file-govco">
          <input type="file" name="inputTypeExample" class="custom-file-input input-file-govco" id="input-file-simple">
          <label class="custom-file-label label-file-govco" for="input-file-simple"></label>
      </div>
  </div>`,
        codejs: `
const configDataFileSimple  = {
  label: 'Añade tu archivo',
  id: 'input-file-simple'
};
window.utils.initInputFile(configDataFileSimple);`
      },
      {
        id: 'multiple',
        titulo: 'Input file múltiple',
        subtitulo: 'Permite añadir varios archivos archivo',
        descripcionComponent: `Se debe `,
        componentRender:
          `
  <div class="form-group">
      <label for="input-file-multiple">Adjuntar archivo</label>
      <div class="custom-file file-govco">
          <input type="file" name="inputTypeExample" class="custom-file-input input-file-govco" id="input-file-multiple" multiple>
          <label class="custom-file-label label-file-govco" for="input-file-multiple"></label>
      </div>
  </div>`,
        codejs: `
const configDataFileMultiple  = {
  label: 'Añade tu archivo',
  id: 'input-file-multiple'
};
window.utils.initInputFile(configDataFileSimple);`
      },
    ]
    this.infoComponent = {
      titulo: "Campo tipo file",
      descripcion: "Son creados para el ingreso de texto de los usuarios dentro de un elemento <form> y su valor varía dependiendo del atributo type. En esta sección se especifica los elementos <input> de tipo text, number, email y password. Los campos de texto podrán tener un contador de caracteres y dependiendo de la complejidad del campo tendrá una descripción de ejemplo con el própósito de guiar al usuario en la manera que debe ingresar los datos."
    }

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    const configDataFileSimple  = {
      label: 'Añade tu archivo',
      id: 'input-file-simple'
    };
    window.utils.initInputFile(configDataFileSimple);

    const configDataFileMultiple  = {
      label: 'Añade tu archivo',
      id: 'input-file-multiple'
    };

    window.utils.initInputFile(configDataFileMultiple);
  }

}